<template>
  <div id="app">
    <router-view :key="$route.path"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  width:100%;
  height:100%;
  min-height:100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue